export const fitInstructions: Record<string, string> = {
  Heroes:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Garment-dyed stretch cotton ',
  'Heroes Slim Taper':
    'Slim fit, with a sharper taper | Mid-rise — sits just below the waist | Garment-dyed stretch cotton',
  'Winter Heroes':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Toasty brushed cotton',
  'Denim Heroes':
    'Slim fit — but not skinny | Denim, cut like a chino | Mid-rise — sits just below the waist | Premium Italian Denim',
  Fives:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Shank button fly | Lightweight stretch cotton',
  'Moleskin Fives':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Shank button fly | Moleskin with 3% stretch',
  'Cord Fives':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Shank button fly | Italian corduroy',
  Sharps:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton',
  'Sharps Slim Taper':
    'Slim fit, with a sharper taper | Mid-rise — sits just below the waist | Italian stretch cotton',
  'Cord Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch needlecord',
  'Cashmere Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian cotton-cashmere blend',
  'Velvet Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Premium Italian velvet',
  'Enduro Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | High-tech non-iron fabric',
  'Summer Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Featherweight stretch cotton',
  'Linen Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Linen-cotton-elastane blend',
  Bulletproofs:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 2-way stretch | Water-resistant cotton',
  Smarts:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 100% Italian wool',
  'Winter Smarts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 100% Italian wool',
  Nomads:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton | 360° stretch waistband',
  'Seersucker Nomads':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton | 360° stretch waistband',
  Hackneys:
    'Wide fit with a light taper | Mid-rise — sits just below the waist | Stretch cotton | British forward pleats'
}

export const fitInstructionsExists = (productType: string) => {
  return fitInstructions.hasOwnProperty(productType)
}
